module.exports = __webpack_public_path__ + "img/task.f37f370d.svg";